"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XHRAuthoriserPlugin = exports.SecurityHeader = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const authoriser_helper_1 = require("../../../security/authoriser/helpers/authoriser.helper");
var SecurityHeader;
(function (SecurityHeader) {
    SecurityHeader["AUTHORIZATION_REQUIRED"] = "Authorization-Required";
    SecurityHeader["SIGNATURE_KEY_EXPIRED"] = "signature-key-expired";
    SecurityHeader["LIMIT_EXCEEDED"] = "limit-exceeded";
    SecurityHeader["NO_TRUSTED_DEVICE"] = "No-Trusted-Device";
})(SecurityHeader || (exports.SecurityHeader = SecurityHeader = {}));
//TODO Manage error within the Authoriser
//TODO Improve compatibility with multiple security flows
class XHRAuthoriserPlugin {
    constructor(authoriser) {
        this.name = this.constructor.name;
        this.requestId = null;
        this.authoriser = authoriser;
    }
    async handleResponse(response) {
        const isLastFlowRequest = this.isLastFlowRequest();
        const { data: { data, httpStatus, responseHeaders: { ['x-security']: securityHeader }, }, reference: { url }, } = response;
        const challengeResponseData = data;
        if (isLastFlowRequest) {
            this.authoriser.updateState({ isFinishing: false });
        }
        // eslint-disable-next-line complexity
        return new Promise(resolve => {
            const resolveLater = () => {
                this.unsolvedResolver = resolve;
            };
            switch (httpStatus) {
                case web_ui_framework_1.HTTP_STATUS.FORBIDDEN:
                case web_ui_framework_1.HTTP_STATUS.FORBIDDEN_AUTHORISER:
                    if (securityHeader === SecurityHeader.AUTHORIZATION_REQUIRED) {
                        this.authoriser.initializeAuthoriser(challengeResponseData, response.calls.originCall, url);
                        resolveLater();
                    }
                    else if (isLastFlowRequest) {
                        this.authoriser.fail();
                    }
                    else {
                        resolve(response);
                    }
                    break;
                case web_ui_framework_1.HTTP_STATUS.PRECONDITION_FAILED:
                    if (securityHeader === SecurityHeader.SIGNATURE_KEY_EXPIRED || securityHeader === SecurityHeader.LIMIT_EXCEEDED) {
                        if (!this.authoriser.state.isStarted) {
                            this.authoriser.initializeAuthoriser(challengeResponseData, response.calls.originCall, url);
                        }
                        this.authoriser.fail(true);
                        return;
                    }
                    resolve(response);
                    break;
                default:
                    if (isLastFlowRequest) {
                        this.unsolvedResolver?.(response);
                        this.reset();
                    }
                    resolve(response);
            }
        });
    }
    async handleRequest(request) {
        this.requestId = (0, authoriser_helper_1.hashRequestURL)(request.url);
        if (this.isLastFlowRequest()) {
            request.headers = {
                ...request.headers,
                progressId: this.authoriser.progressId,
            };
            this.authoriser.updateState({ isFinishing: true });
        }
        return request;
    }
    isLastFlowRequest() {
        return this.requestId === this.authoriser.requestId && !!this.authoriser.progressId;
    }
    reset() {
        this.unsolvedResolver = undefined;
        this.authoriser.reset();
    }
}
exports.XHRAuthoriserPlugin = XHRAuthoriserPlugin;
//# sourceMappingURL=xhrAuthoriserPlugin.js.map